module.exports = __webpack_public_path__ + "img/icon-share.fd120cbd.svg";